import { SVGProps } from 'react';
export const RenewBilby = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		id="Layer_2"
		data-name="Layer 2"
		viewBox="0 0 805.84 847.11"
		{...props}
	>
		<defs>
			<style>
				{
					'.cls-5{fill:#1c3653}.cls-9{fill:#000523}.cls-17{fill:#1d3653}.cls-27{fill:#feac78}.cls-34{fill:#1d3754}.cls-35{fill:#a4b0be}.cls-40{fill:#fefefe}.cls-42{fill:#fdbd50}'
				}
			</style>
		</defs>
		<g id="Layer_1-2" data-name="Layer 1">
			<path
				d="M803.03 559.39c-1.31-4.12-8.52-19.97-13.77-17.79-2.76 1.14-.81 5.57-3.25 6.32-2.49-7.26-6.02-14.07-7.94-21.57-1.05-4.11-3.22-22.81-3.96-23.84-2.71-3.77-12.55 6.27-14.62 8.4-26.7 27.49-44.19 82.48-.43 102.68-5.9 63.99-89.63 93.8-128.05 37.82l17.51 4.48c12.08.99 31.41-6.6 37.94-17.02 5.83-9.29-4.44-12.75-4.44-14.46 0-1.03 7.33-4.03 4.41-13.47-2.43-7.86-19.77-5.27-18.28-13.4.29-1.57 21.36-16.76 24.87-20.11 37-35.3 41.29-64.45 1.46-99.49-14.71-12.94-32.47-22.17-47.27-34.73.96-30.56 3.25-61.31 6.92-91.67 5.24-43.44 7.99-64.82 34.48-100.52 36.34-48.97 75.95-83.13 84.27-148.73 1.37-10.77 2.76-45.51-3.82-53.66-5.33-6.61-23.61 5.44-28.97 8.88C675.81 98.77 652.96 170.6 635 240.93c-7.47-2.77-14.67-7.09-22.98-7.01-.37-27.37 7.66-53.89 9.99-80.99.09-14.52.43-29.19 1-44-1.7-32.33-15.83-73.68-37.03-98.47C570.1-8.11 567.26.3 558.83 18.25c-10.36 22.07-20.29 53.86-21.81 78.19-2.32 37.03 11.67 73.13 26.97 106.01.87 2.9-3.89.69-5.33.83-10.71 1.07-6.31 9.73-3.65 16.64-9.42-3.1-18.77-10.37-28.76-11.73-4.92-.67-20.27-1.97-20.32 5.22-.04 6.89 15.63 17.7 19.06 24.02-5.65 3.19-11.88 4.23-17.65 7.33-31.06 16.69-33.62 54.67-62.02 73.98-21.05 14.31-40.63 11.42-64.82 10.19-2.03-.39-5.95-7.13-8.48-9.52-9.25-8.71-23.68-14.04-36.01-9.49v-198c-1.36-3.02-3.52-6.34-7-7-1.28.66-1.95.66-2 0-1.04-1.66-3.79-1-5.49-1.02-28.6-.3-57.21.43-85.81-.19l-54.55-32.94c.76-10-4.16-17.16-14.68-16.91-11.23.26-12.81 8.2-14.49 17.56-18.06 10.46-35.54 22.5-52.99 33.51-30.06.62-60.26.78-90.59.47-3.63.37-6.33 3.15-7.61 6.48C.89 234.34.63 356.35 0 477.93c.89 3.42 3.34 7.18 7 8 1.13-.49 4.22-1.11 3 0l228.99 1.01c-1.92 5.25 4.24 10.95 4.81 13.72.47 2.25-1.42 6.41-.57 10.54 1.43 6.96 9.98 11.37 16.35 12.65 2.44.49 5.24-.4 7.71.29 1.4.39 3.81 3.2 5.81 4.19 5.99 2.98 14.74 4.1 21.39 3.58 3.37-.26 13.13-3.9 13.84-3.78.95.17 3.32 2.29 4.99 2.98 26.61 10.99 62.31 18.07 90.22 8.85 5.7-1.88 10.78-5.21 16.47-7.02-4.95 13.29-8.9 27.92-11 41.99-5.2 66.1-5.34 138.13 7 203-.2.57.5 2.04-.49 1.99-26.74-12.29-70.84-2.57-80.51 28.01-3.5-.01-5 9.67-3.11 11.21 3.21 2.61 18.61 5.08 22.11 1.79 26.51.6 53.51.54 80 0l3.12 1.89c4.74.38 30.5-.54 33.86-3.65 3.27-3.02-1.4-20.92-2.62-21.22-.43-.11-.89-.08-1.36-.02l1.41-3.51c-5.41-30.78-14.47-92.4 26.55-102.14 55.33-13.15 85.03 44.34 96.56 88.62-7.18.23-14.29 2.03-20.67 5.35-4.1 2.13-11.31 5.88-10.85 10.69-5.67.8-9.19 9.8-11 14.91-4.35 12.29-2.41 15.76 10.52 17.38 14.14 1.76 91.74 1.89 99.32-5.92 3.3-3.4.35-14.2-3.84-15.37-11.34-36.37-20.26-71.64-22.99-110l15.64 8.85c64.96 26.38 134.42-25.26 136.52-93.19 20.29-11.15 25.7-32.79 18.87-54.2Zm-163.54-49.46c7.9 5.74 25.65 11.8 24.55 23.5-.82 8.69-22.43 27.59-29.03 34.49l4.48-57.99ZM111 104.92c-.84-1.72.32-1.67 1.26-2.27 14.4-9.23 29.67-17.4 44.1-26.62 7.09 7.29 15.59 6.11 22.96.02l44.69 28.87h-113Zm354.77 321.27c-2.79 6.91-7.05 7.36-12.24 11.76-40.13 34-59.83 59.99-117.91 51.85L325 486.93c4.22.82 10.51-4 10.99-8.01v-126l10.32 6.18c33.36 15.92 63.56 34.79 98.43 48.57 5.51 2.18 17.52 5.01 21.57 7.42 3.12 1.85.62 8.18-.55 11.1Z"
				className="cls-34"
			/>
			<path
				d="M560 796.92c-3.73 4.07-7.75 10.9-9.3 16.2-2.43 8.31-3.89 12.24 5.91 13.69 22.14 3.27 72.7 1.71 94.59-3.19 1.93-.43 7.21-1.28 7.67-3.31.14-.63-3.26-10.44-3.87-12.39 1.4-.99.06-3.13 2.25-2.82 12.38 1.78 62.22 11.69 28.73 25.3-18.12 7.37-50.56 10.64-70.49 12.51-53.9 5.08-108.92 4.84-162.95 2.96-38.9-1.35-93.66-2.8-130.3-14.7-33.7-10.94-6.03-22.21 12.76-23.26-.55 1.72-2.6 8.98-1.93 9.92 6.71 2.2 13.88 2.76 20.93 3.08 26.66.6 53.34.54 80 0 7.51-.31 16.1-.31 23.49-1.01 2.98-.28 12.7-.7 13.12-3.45.36-2.41-2.95-14.88-3.61-18.54l.96-4.12c28.5-1.13 58.15-2.09 87 .47 1.88.5 3.56 1.39 5.04 2.66Z"
				style={{
					fill: '#bae4e9',
				}}
			/>
			<path
				d="M99 104.92c-.62.39-1.08 1.41-2.39 1.06l-88.16-.11c-2.94-.02-6.62 4.06-7.24 6.76-1.52 119.9 1.29 239.9-.19 359.8-.02 1.69.64 4.45-1.02 5.49l.21-366.29c1.21-3.57 4.36-6.56 8.27-6.73l90.52.02Z"
				style={{
					fill: '#00031e',
				}}
			/>
			<path
				d="M416 777.92c-7.26-30.41-9.89-62.7-10-94l-1-12c-.05-12.98-.04-26.02 0-39l1-13c.04-14.88.8-30.27 3-45 2.2 6.67-.48 15.48-.99 22.51-3.54 49.25-2.44 104.9 4.13 153.85.83 6.2 5.31 22.39 3.86 26.64Z"
				style={{
					fill: '#14213e',
				}}
			/>
			<path
				d="M7 485.92c1.04-1.66 3.79-1 5.49-1.02 74.32-.92 148.7.73 223.02.02l3.48.99H10c-.94-.12-2.15.2-3 .01Z"
				style={{
					fill: '#000c2d',
				}}
			/>
			<path
				d="M327 104.92c.64.08 1.39-.12 2 0-1.04 1.66-3.79 1-5.49 1.02-27.37.34-56.82 1.1-84.02-.02-1.22-.05-3.72.75-3.48-.99H327Z"
				className="cls-9"
			/>
			<path
				d="M622 152.92c-2.71-4.29-.13-10.04.04-14.46.31-7.98-.16-16.06-.06-24.06.02-1.69-.64-4.45 1.02-5.49.73 13.92.2 30.1-1 44Z"
				style={{
					fill: '#000623',
				}}
			/>
			<path
				d="M405 632.92c.01-4.11-.85-9.68 1-13-.01 4.11.84 9.68-1 13ZM406 683.92c-1.84-2.98-.98-8.22-1-12 1.84 2.98.99 8.22 1 12Z"
				className="cls-34"
			/>
			<path
				d="M654.31 309.74c9.79-51.4 47.72-79.54 75.91-120.09 24.07-34.63 41.28-77.11 37.76-120.21-.23-2.77-2.33-15.76-4.61-16.44-5.46-1.64-33.48 19.42-38.84 23.95-55.03 46.52-70.79 116.58-88.75 183.25-.44 1.59-1.8 2.18-3.27 1.71-4.29-1.36 1-13.49.06-15-3.16-5.05-22.58-6.21-25.35-8.2-2.72-1.95-.57-22.78-.09-27.17 4.01-36.6 13.51-68.08 9.86-106.12-3.48-36.26-18.17-74.01-44.49-99.49-1.49 0-8.52 14.76-9.67 17.31-28.74 63.26-24.4 118.19 7 179.35 3.81 7.42 5.23 5.97 10.18 10.82 3.33 3.25 14.98 15.32 13.85 19.8-2.2 8.76-9.09-6.42-10.45-8.2-5.74-7.52-16.03-14.62-25.41-16.08-1.48 4.42 9.75 23.24 7.99 24.99-6.46-.56-11.46-6.7-17.32-10.17-10.31-6.09-24.67-12.66-36.67-9.82-1.22 1.2 20.76 21.5 22.05 23.44 1.86 2.78.89 4.01-2.04 5.07-6 2.16-11.99 2.65-18.37 5.63-37.19 17.33-35.61 66.06-78.96 83.04-17.92 7.02-34.14 4.81-52.69 2.81.94 7.87-1.49 16.61-7.5 22-3 2.69-6.95 3.2-9.49 5.99 11.58 5.52 22.6 12.11 34 18.01 42.86 15.03 92.65 8.62 136.21-3.23 57.81-11.21 61.56 8.65 53.34 61.01-7.35 35.92-11.9 72.39-13.63 109.41-4.32 48.06-21.07 105.08-76.88 110.95-43.99 4.63-72.38-23.62-82.85-63.14l-2.19-1-2.04 24.46c.03 37.73-.63 75.48 3.05 113.04.88 8.99 5.29 45.51 9.97 51.03 1.53 1.8 5.01 3.14 7.05 4.95.83.74 3.27 2.75.98 3.53.69 1.37 1.54 2.68 2.81 3.57 3.54 2.5 24.64 15.16 26.75 15.42.8.1 1.62.07 2.44 0-.76-8.26-4.6-18.69-5.86-27.64-5.99-42.74-5.49-99.06 51.36-99.44 54.77-.37 78.3 56.68 91.71 100.87 9.23 2.05 18.17 5.5 26.46 10.04 6.28 3.45 14.43 8.21 17.33 14.17-3.06 3.06 2.07 11.71 6 8-12.8-47.12-23.78-85.62-26.04-135.46-.43-9.43 1.62-24.71.02-33.02-.39-2.02-4.36-5.67-5.78-8.22-10.58-19.03-8.39-34.24 2.01-52.59 6.65-11.74 7.38-9 8.78-24.22l3.05-54.82c-.35-1.43-12.6-4.6-11.98-8.05.16-.89 2.06-2.56 3.25-2.45 2.77.25 20.76 9.58 24.36 11.66 14.75 8.49 28.61 16.89 16.74 35.08-13.2 20.21-39.52 34.55-45.91 60.09-7.18 28.69 12.7 52.44 42.71 44.71 7.25-1.87 30.72-15.93 14.44-19.87-4.49-1.09-11.59.39-15.57 2.74-3.57 2.11-6.87 8.13-11.08 9.94-1.44.62-2.54.28-2.95-1.1-1.11-3.76 3.93-6.36 5.92-8.95 4.69-6.08 10.84-15.73 11.63-23.46.16-1.58-.96-7.54-1.62-8.02-.33-.24-7.25 2.98-5.85-2.34.3-1.14 16.57-11.57 19.32-13.69 39.11-30.11 58.79-62.26 15.56-100.47-14.38-12.71-33.59-21.63-46.93-33.07-6.99-5.99-3.42-11.47-3.09-18.93 1.75-39.36 4.96-83 12.33-121.67Z"
				className="cls-35"
			/>
			<path
				d="M331 477.92c.87-43.24.94-88.61 0-132-6.7-13.23-8.2-18.12-.97-32.47L330 167.92h-66c-17.95-.07-36.39-.89-54-1-41.31-.95-82.69-1.03-124 0-.18 0-1.56 1.05-3.38 1.07-25.53.28-51.1-.36-76.62-.07v310c1.48 1.03 2.46 1.92 4.45 2.05 48.61 3.36 103.56-.69 153.07-.07 1.69.02 4.45-.64 5.49 1.02 24.48.87 50.41.89 75 0 .19-1.59-2.06-4.4-2.09-7.49-.09-9.56 9.13-12.52 17.08-9.51-2.03-9.67-3.25-20.34-.99-29.99-1.69.27-9.59-.42-9.99 0-.32.33-.73 6.62-1.54 8.96-8.86 25.77-46.33 22.76-48.48-4.97-15.48.04-30.93 2.14-46.4 2.92-14.82-3.51-16.4-16.93-6.14-26.96 2.01-1.97 4.95-2.94 6.56-4.72 10.92-12.14 1.31-43.51 1.95-58.78.78-18.86 10.87-39.72 26.71-50.28 2.15-1.43 11.49-5.58 11.87-6.13.92-1.37.39-7.31.91-10.09 3.88-20.67 30.81-21.4 36.6-1.51.71 2.43.79 7.76 1.38 8.62.41.6 10.82 4.01 13.48 5.52 5.68 3.2 11.95 11.41 15.11 12.97.95.47 11.92-4.26 15.48-4.54 41.06-3.2 46.51 60.92 4.46 64.55-.63 3.64 2.37 20.38 4.25 23.72 1.78 3.16 7.35 5.29 10.26 7.74 21.76 18.27 7.57 33.01-16.47 31.47 4.72 11.83 7.59 21.8 16.97 31.03 2.08 2.04 19.44 16.89 20.73 17.27 2.2.65 9.19.45 11.62-.02 2.44-.47 2.31-1.81 3.68-2.78ZM591.18 387.24c-14.41-30.38-65.37-8.58-89.99-4.64-22.06 3.54-44.41 4.59-66.67 3.3l-35.51-5.99c14.1 7.3 28.37 14.31 43.03 20.47 4.63 4.1 41.34 12.9 41.96 15.04 1.95 6.73-10.54.98-10.98 1.49-.15 7.38-3.01 14.23-5.54 20.97-9.7 25.85-25 50.64-35.22 76.78-7 17.9-21.68 61.19-19.25 79.25 1.49 11.05 12.85 32.67 20.02 41.48 24.3 29.87 74.36 33.33 103.99 9.03 45.13-37 38.92-114.08 46.13-166.87 3.04-22.27 17.03-71.36 8.04-90.32Z"
				className="cls-40"
			/>
			<path
				d="M327 111.92c2.36.3 3.35 2.86 2.96 7.66-.38 14.01-.54 28.03-.49 42.05-24.36-.15-48.52-.05-72.47.29-1 .01-2-.01-3 0-78 .8-156 .74-234 0-4.65-.04-9.35.03-14.01 0 1.29-7.6-2.1-46.11 1.01-50.01 105.19-.88 214.91-.88 320 0Z"
				style={{
					fill: '#7dbed7',
				}}
			/>
			<path
				d="M146.28 432.64c-8.44-8.5 8.21-16.97 11.73-22.21 11.07-16.5.05-46.22 2.12-65.88 4.45-42.42 58.16-65.85 90.34-37.59 9.22 8.1 3.19 7.18-.65 15.29-9.51 20.07 2.48 44.48 24.75 47.61 1.02 9.2 1.3 24.81 8.93 31.07 2.47 2.02 5.82 3.15 8.51 5.49 9.17 7.99 12.31 16.83-2.61 19.4-23.12 3.98-52 2.58-75.88 4.12-18.21 1.17-36.73 4.48-54.96 5.03-3.48.1-9.68.28-12.26-2.32Z"
				style={{
					fill: '#febd50',
				}}
			/>
			<path
				d="M371.37 496.79c-11.63 1.06-34.49.2-45.59-3.15-11.25-3.4-40.74-30.82-46.33-41.67-1.6-3.1-5.41-15.71-6.72-16.78-1.08-.88-5.55-1.54-7.03-1.12-7.01 2.02-2.35 23.61-.74 29.16 10.61 2.93 23.6 4.97 17.25 19.41-.68 1.55-2.95 3.01-3.11 3.93-.14.81 7.3 12.67 8.94 13.81 4.02 2.82 17.7 1.93 10.92 6.99-3.73 2.79-7.26.96-11.01-.9-4.26-2.11-3.35-5.04-8.95-1.54 2.23 2.58 2.45 5.07 1.94 8.42-.65 4.22-3.87 6.14-5.45 9.57 8.42 4.24 18.3 3.8 27.07 1.04 2.24-.7 4.91-3.42 6.75-2.95 1.04.27 3.59 3.37 5.65 4.45 3.78 1.99 8.94 3.6 13.06 4.94 31.35 10.23 66.34 13.97 94.44-6.54 10.75-27.96 24.08-54.76 37.54-81.47l-.48-1.48c-25.52 19.05-54.75 52.81-88.13 55.87Z"
				className="cls-35"
			/>
			<path
				d="M777.99 614.93c-2.41 59.99-58.51 104.7-117.82 90.32-10.38-2.52-21.58-8.22-28.42-16.58L630 659.93c44.85 53.08 126.93 20.77 135.07-44.93 4.68.56 8.22 1.37 12.92-.07Z"
				style={{
					fill: '#a3afbe',
				}}
			/>
			<path
				d="M739 581.92c-4.56-22.84 9.58-56.39 27.99-70.51 1-.77 1.27-1.94 3-1.49.2 17.65 8.82 33.02 15.1 48.89 6.91 2.32 4.76-7.58 5.91-8.9 1.43-1.64 1.77.57 2.24 1.29 6.95 10.7 8.62 26.73 4.76 38.71l-2.12-.48c-6.49 11.36-15.06 15.03-20.83.45-11.9 22.03-27.56 9.05-33.67-8.54l-2.38.57ZM432 790.92c11.17 5.13 21.74 12.29 32 19 .09.94.16 1.96-.1 2.88-1.81 1.94-43.36 2.04-49.41 2.1-1.69.02-4.45-.64-5.49 1.02-10.96.86-22.05 1.24-33 0-.31-2.49 7.87-16.16 7-16.99-3.49-3.3-11.48 12.93-11 15.99h-18c.79-2.95 2.11-6.3 3.47-9.03 1.99-4.01 4.83-7.01 6.52-10.97-6.11-.7-9.48 7.02-11.85 11.64-4.22 8.25.14 8.79-12.15 7.35 1.27-14.53 16.25-26.14 29.22-30.28 21.07-6.73 43.27-1.68 62.78 7.28ZM645 807.92c1.45 2.98 1.74 7.65 6 8 .03.12 1.5.45 1 1.99-19.23 2.45-38.61 3.3-57.99 4-1.48-1.31 7.55-15.01 5.5-17.99-7.33 3.47-7.73 11.65-11.01 17.99H570c.79-3.99 2.12-7.99 3.82-11.68.72-1.58 5.82-8.72 5.18-9.31-4.05-3.72-14.27 17.13-13 21l-10.99-1.01c1.45-12.82 11.06-24.87 23.01-29.48 23.42-9.03 46.98 5.84 66.99 16.49Z"
				className="cls-40"
			/>
			<path
				d="M276.67 309.31c31.89-.1 36.41 49.41 5.38 55.16-38.18 7.06-43.63-55.04-5.38-55.16Z"
				style={{
					fill: '#fe813b',
				}}
			/>
			<path
				d="M375.49 345.91c6.98-17.75-18.91-35.03-34.76-31.76-4.51.93-8.95 5.79-9.66 10.33-4.38 27.8 35.82 43.3 44.42 21.42Z"
				style={{
					fill: '#feac79',
				}}
			/>
			<path
				d="M739 581.92c2-5.2.79-11.88 1-17.51.05-1.21-.75-3.72.99-3.48.86 3.83-.33 7.35.12 11.39 1.15 10.28 12.16 34.01 25.26 25.47 4.2-2.74 4.59-9.84 9.14-9.95 3.02-.07 3.8 11.54 9.52 9.67s9.76-9.27 11.51-14.55c.9-2.73-.45-5.93 1.97-8.03 1.98 4.6-3.39 10.64-.5 14.99-10.11 31.39-52.75 23.32-59-8Z"
				style={{
					fill: '#e1f2f3',
				}}
			/>
			<path
				d="M242 433.92c0 26.51-35.96 29.22-39.02 2.54-.03-1.96 35.57-2.7 39.02-2.54Z"
				className="cls-42"
			/>
			<path
				d="M250.71 468.11c4.16-1.23 13.26 3.48 18.55 2.05 5.95 1.92 11.09 2.95 7.97 10.51-4.62 11.19-33.33 4.24-29.04-10.04.35-1.18 1.33-2.17 2.51-2.52Z"
				style={{
					fill: '#adb7c3',
				}}
			/>
			<path
				d="M226 289.92c-9.47-.14-18.78-.39-28 2 .11-23.51 25.59-25.46 28-2Z"
				className="cls-42"
			/>
			<path
				d="M274.99 489.92c.17.21-.34 1.86.29 2.67.57.74 1.96.97 2.6 1.92 6.1 9.19-14.57 7.96-19.29 7.32-7.21-.98-15.18-6.84-13.59-14.92 8.83.95 13.54 5.82 23.39 4.89 1.76-.17 6.39-2.16 6.6-1.89Z"
				style={{
					fill: '#abb6c3',
				}}
			/>
			<path
				d="M328 109.92c-104.77.88-214.98.88-320 0h320Z"
				style={{
					fill: '#091534',
				}}
			/>
			<path
				d="M327 110.92c.87.28.86.62 0 1H7c.28-.35.49-.9 1-1 104.45-.88 214.31-.88 319 0Z"
				style={{
					fill: '#99e9fb',
				}}
			/>
			<path
				d="M328 109.92c.13.04-.14.89 0 1-.29.81-.62.8-1 0H8v-1h320Z"
				style={{
					fill: '#3b5c77',
				}}
			/>
			<path
				d="M249.56 504.95c4.7 4.16 23.93 1.17 25.33 5.64 3.06 9.76-18.43 11.2-24.72 1.66-1.47-2.23-3.53-5.57-.61-7.3Z"
				style={{
					fill: '#acb6c3',
				}}
			/>
			<path
				d="M169 480.92h75c-.19 1.53-1.35.9-2.48 1.02H9.5l1.98-1.02H169Z"
				style={{
					fill: '#000b2b',
				}}
			/>
			<path
				d="M254 161.92H20c77.88.74 156.12.81 234 0Z"
				style={{
					fill: '#05102e',
				}}
			/>
			<path
				d="M86 166.92c-8.14-.25-16.37.34-24.51 0-1.23-.05-3.71.76-3.49-1h193c.22 1.76-2.26.95-3.49 1-12.46.52-25.05-.38-37.51 0-41.28-.25-82.72-.43-124 0Z"
				style={{
					fill: '#000520',
				}}
			/>
			<path
				d="M680.73 612.18c6.46 6.62-12.43 10.17-15.72 11.74l5.04-14.97c.83-.6 9.6 2.13 10.68 3.24Z"
				style={{
					fill: '#acb7c4',
				}}
			/>
			<path
				d="m332 478.42.06-129.1c.48-1.71-.55-2.38-1.06-3.4v132s.95 1.75 1 .5Z"
				style={{
					fill: '#00031c',
				}}
			/>
			<path
				d="M328 110.92c1.6 1.29 1.74.88 2.05 3.43 1.82 14.81-1.46 33.34-.06 48.57l-72.99-1c.18 0 1.55-1.05 3.38-1.07 22.86-.27 45.77.35 68.62.08-1.35-14.28 1.77-31.69.05-45.58-.21-1.68-.28-2.82-2.06-3.43v-1h1Z"
				style={{
					fill: '#97e6f8',
				}}
			/>
			<path
				d="M434 820.92c-26.29 1.08-53.67 1.21-80 0h80Z"
				style={{
					fill: '#010928',
				}}
			/>
			<path
				d="M330 167.92c-21.98-.06-44.02.09-66 0h66Z"
				style={{
					fill: '#010722',
				}}
			/>
			<path
				d="M409 815.92c3.49.02 7.02-.14 10.51 0 1.21.05 3.72-.76 3.48.99-14.26-1.05-30.5 1.43-44.52.03-1.13-.11-2.29.51-2.48-1.02 10.99.05 22.01-.07 33 0Z"
				className="cls-9"
			/>
			<path
				d="M750.99 78.93c3.37 36.99-8.37 71.61-28.36 102.13-17 25.95-42.64 45.5-61.62 69.87.61-11.6 2.92-23.77 5.28-35.21 9.85-47.63 26.16-89.04 63.23-121.77 1.99-1.76 20.04-16.63 21.47-15.02ZM571.99 35.92c5.47 12.89 12.51 25 17.29 38.23 16.49 45.68 11.53 96.16 1.72 142.77l-7.16-14.32c-22.78-53.07-39.16-100.53-17.57-157.92.56-1.49 3.41-10.49 5.73-8.75Z"
				className="cls-27"
			/>
			<path
				d="M571.73 299.16c32.01-5.42 32.68 52.79-1.23 52.83-28.57.04-26.03-48.21 1.23-52.83ZM502.81 287.15c23.99-1.25 28.97 42.46 3.41 50.49-35.53 11.16-34.44-48.88-3.41-50.49Z"
				className="cls-17"
			/>
			<path
				d="M605.01 294.92c-1.97-7.76-11.69-15.5-19.2-17.31-2.64-.64-11.56.06-10.81-3.17 9.46-8.58 30.02 2.56 32.56 13.42.63 2.68 1.5 7.12-2.55 7.07Z"
				style={{
					fill: '#1b3452',
				}}
			/>
			<path
				d="M519.99 272.92c-6.32-1.51-10.28-4.08-17.26-2.76-2.8.53-6.43 3.35-9.24 3.77s-1.57-3.2-.56-4.58c5.7-7.81 26.9-9.6 27.06 3.56Z"
				style={{
					fill: '#1b3451',
				}}
			/>
			<path
				d="M131 278.42c.5-1.62 3.46-1.67 5-1.5l1 44.01c2.05-.25 14.82.08 15.06 1.58.21 1.3-.22 3.01-.06 4.42l-15-1v49c3.14.18 6.4-.26 9.54 0 1.84.15 2.51-.87 2.48 1.51-.07 5.94-7.94 2.76-12.02 3.49v32.5c0 1.88-5 1.88-5 0v-32.5c-17.96 1.72-16.24-5.71 0-5l-1.01-49h-45v21.5c0 1.65-6 3.28-6-2v-18.5c-22.08 1.82-22.39-7.98 0-6v-41c0-.62 6-.62 6 0v41h45v-42.5Z"
				style={{
					fill: '#77b7d1',
				}}
			/>
			<path
				d="M73 232.93c2.82 2.79-11.17 13.37-13.51 15.98-25.5 28.44-23.09 66.57 1 95.03 8.1 9.57 28.21 26.26 40.03 29.97.51.16 1.63.27 1.48-.48-3.07-1.77-16.4-22.32-5-17.01 1.2.56 15.06 19.8 15.6 21.48 1.01 3.16-1.39 4.79-3.9 6.21-3.47 1.97-20.71 8.19-24.36 8.51-4.03.35-4.54-2.95-1.9-5.77l17.56-6.92c-53.96-19.96-88.86-85.28-45.97-134.48 2.36-2.71 15.29-16.16 18.97-12.52ZM220.99 225.92c.78-4.17 5.26-22.25 7.62-23.93 1.39-.99 4.07-1.14 5.15.18 1.71 2.1 5.5 23.76 6.74 23.76 1.81-3.05 5.42-24.11 6.58-24.94s5.2 1.16 6.92.94c-4.08 10.66-5.57 24.3-9.86 34.61-1.13 2.71-5.67 1.79-7.06-.19-1.56-2.21-5.32-21.46-6.57-21.44-1.54 2.76-6.61 22.23-7.64 22.87-.64.4-5.08.4-5.72 0-1.58-.98-9.33-31.33-10.05-35.75 1.87-.63 4.95-2.16 6.43-.12 1.78 2.46 4.15 17.13 5.58 21.41.37 1.1.3 2.42 1.89 2.6Z"
				className="cls-5"
			/>
			<path
				d="M80 401.42c.88-5.24 6-6.01 6-2v28.5c10.94.46 25.91-2.91 36.5-1 3 .54 3.73 3.33.84 4.83-14.29 1.54-28.54.84-42.88 1.12-2.63.05-5.06 1.05-7.91 1.09-4.63.06-29.53.84-30.53-2.56-.36-1.22.63-3.49 1.49-3.49h36.5c.95-8.04-1.28-18.84 0-26.5Z"
				style={{
					fill: '#78b8d2',
				}}
			/>
			<path
				d="M148 202.92c.8.65 1.9.99 2.4 2.05l13.6 18.95v-20.5c0-1.22 7-3.67 7-1v34.5c0 .34-5.71 1.75-6.58.08-2.16-3.03-14.49-23.11-16.42-23.08-.48 7.34-.64 14.8-.49 22.39-.16.25-4.66.69-5.01.46-1.45-.95-.79-33.46.62-34.47.93-.67 4.02-.49 4.88.62Z"
				className="cls-5"
			/>
			<path
				d="M100 203.92c1.27.28 3.17 2.49 3.77 3.73 5.1 10.53-6.01 15.1-5.64 17.58.42 2.76 14.05 12.73 4.39 12.76-4.15.01-12.03-10.07-12.52-13.07 1.16-1.14-4.69-.64-4.42.42l-.08 12.01c-.17.23-4.2.42-4.5-.44-.86-10.61-1.15-22.32-.98-33.33 0-.23.43-.45.98-.67 7.31-1.3 13.64-.97 19 1Z"
				className="cls-17"
			/>
			<path
				d="M113 210.92c-2.08-2.05-.62-6.18-1-9h22c1.81 9.55-8.86 5.06-15.01 5.99v8.01c6.14.8 15.72-3.31 14.01 5.99-5.94.95-15.11-3.43-14.08 5.52.85 7.37 14.91.89 16.07 4.48-.18 1.96-.62 3.47-1.31 4.53l-20-.03-.2-26.09-.49.59Z"
				style={{
					fill: '#1c3552',
				}}
			/>
			<path
				d="M202 231.92c-4.96.33-9.96.66-15 1 4.34-.88 10.45-.82 15 0 .79.45.86 2.3 0 3-6 .53-13.48 1.17-19.5 0-.95.69-1.79-.31-1.5-1.5-.21-.08-.39-.17-.43-.31-.49-1.45-.82-29.06-.39-30.52.08-.28.42-.49.82-.67 3.61-.44 17.82-2.07 19.73.46l.27 3.54c-1.19 1.21-.71.84-2.49 1.01-3.99.38-8.47-.3-12.52-.02v8.01H200v6.01c-2.86.49-12.07-1.12-13.56.97.69 1.63.28 7.74.56 8.03.86.89 12.59-1.48 15.01.99Z"
				className="cls-17"
			/>
			<path
				d="M71.5 375.92c3.16.47 3.64 3.34 0 3.99-4.6-1.41-27.13 2.88-29.06.07-.77-1.12-.38-2.78-.44-4.06 9.11.96 20.73-1.3 29.5 0Z"
				style={{
					fill: '#74b6d0',
				}}
			/>
			<path
				d="M202 231.92c1.52 1.55 1.03 2.93 1 5-4.06-.78-19.65 1.25-22.07-.44-1.78-1.24-.8-15.78-.9-19.1-.11-3.8-3.61-14.53 1.46-15.46 2.06-.38 17.08-.46 18.83-.04 1.29.31 2.16 3.52.67 5.04-1.59-.66-.37-3.84-1.57-4.06-5.06-.95-12.99.83-18.43.06v31.5c0 .11 1.39 1.5 1.5 1.5h19.5v-3h-15v-.99l15-.01Z"
				style={{
					fill: '#0b112c',
				}}
			/>
			<path
				d="M100 203.92c-.05-.01.1 1.18-.55.97-6.68-2.08-11.25-2.51-18.45-1.97v34c0 .2 3.85.14 4 0 .47-.45-.33-11 0-13.01l6.01.02c.19.62-1.02.91-1.01.98-1.54.43-3.82-1.38-4.01 1.47-.26 3.81.2 7.73.01 11.54h-6.01l-1-36.01c7.38.02 14.19-2.31 21.01 2Z"
				style={{
					fill: '#1e273f',
				}}
			/>
			<path
				d="M148 202.92c-1.2.27-4.82-.68-5.02.58-.45 2.9-1.15 31.31.02 32.43.14.14 3.85.14 3.99 0 .67-.64-.17-15.58 0-18.51.07-1.23-.63-3.31 1.01-3.49-.54 3.15.75 22.13-.06 22.95-.21.21-4.82.52-5.94 1.05v-36c0-.22 3.58-1.04 4.34-.87 1.19.27 1.29 1.57 1.66 1.87Z"
				style={{
					fill: '#050720',
				}}
			/>
			<path
				d="M113 210.92c.03-1.44-.86-5.79.99-5.99v31c5.78-.79 14.05 1.04 19.44.06 1.25-.23-.06-3.58 1.57-4.06.38 1.16-.24 3.57 0 5.01h-22.01c.14-8.65-.17-17.36 0-26.01Z"
				style={{
					fill: '#01051e',
				}}
			/>
			<path
				d="M566.75 388.15c13.38-1.96 5.62 17.9 2.43 24.45-14.26 29.21-46.8 31.56-64.99 4.64-2.2-3.26-10.83-17.01-4.52-19.15 9.65-.49 19 1.61 28.7.71 13.73-1.27 26.65-8.93 38.38-10.64Z"
				style={{
					fill: '#1e3654',
				}}
			/>
			<path
				d="M172 363.42c-.8 2.61-6.19 2.12-6.97-2.03-.69-3.68-.38-14.84-.01-18.96.61-6.82 3.47-15.08 7.16-20.84 2.18-3.4 12.06-15.21 15.9-10.26 3.54 4.55-3.75 7.35-6.59 10.57-3.28 3.72-9.49 15.8-9.49 20.51 0 4.35.89 18.1 0 21Z"
				style={{
					fill: '#fed79d',
				}}
			/>
			<path
				d="M283 354.42c-.71 2.3-6.22 2.13-7.5-.5-1.86-3.81.58-21.61-.51-23-9.71 3.37-2.26-7.47 2.73-8.85 1.84-.51 5.27 1.01 5.27 2.35 0 5.82 1.17 26.24 0 30Z"
				style={{
					fill: '#fefcfa',
				}}
			/>
			<path
				d="M567.01 347.92c-.29-2.86 3.35-2.63 5.54-4.95 12.22-12.98-6.46-36.89-16.56-18.05-1.84.21-1.01-3.34-.76-4.26 5.55-20.39 33.69-23.6 35.81-.27 1.44 15.87-6.46 29.94-24.04 27.54Z"
				style={{
					fill: '#fdfefe',
				}}
			/>
			<path
				d="M566.85 325.06c4.31 2.7-5.07 10.37-4.53 2.52.17-2.43 2.25-3.94 4.53-2.52Z"
				style={{
					fill: '#e7eaec',
				}}
			/>
			<path
				d="M498.01 335.92c-.19-2.73 2.66-2.69 4.43-5.06 10.81-14.49-9.56-35.35-18.44-14.45-1.48 1.6-.91-.95-.76-1.73 1.57-7.74 6.89-19.76 15.49-21.53 22.24-4.58 26.59 27.75 11.76 38.76-4.44 3.3-7.49 2.58-12.48 4.01Z"
				style={{
					fill: '#fdfdfe',
				}}
			/>
			<path
				d="M493.51 313.93c4.5-1.35 4.06 5.35.97 5.98-2.88.59-3.51-5.22-.97-5.98Z"
				style={{
					fill: '#f1f3f5',
				}}
			/>
			<path
				d="M96.76 209.16c5.94 5.97-4.49 12.35-10.76 9.77v-11.01c2.75.2 8.81-.72 10.76 1.24Z"
				style={{
					fill: '#fcfcfc',
				}}
			/>
			<path
				d="M525 428.91c5.13-11.8 22.6-14.49 32.97-8.5-7.2 11.1-21.06 12.44-32.97 8.5Z"
				style={{
					fill: '#fcae7a',
				}}
			/>
		</g>
	</svg>
);
